<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="New"
      @click="fnShowModal()"
    >
      New
    </button>

    <b-modal ref="modal" size="lg" hide-footer title="EM Email Template - New">
      <div class="d-block">
        <form v-on:submit.prevent="createNew">
          <div class="row">
            <div class="col-md-3 col-12">
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_status"
                  placeholder=" "
                  value-field="id"
                  text-field="text"
                  :options="optionCategory"
                  v-model="categoryId"
                ></b-form-select>
                <label class="floatingLabel" for="status">Category</label>
                <div class="invalid-feedback" v-if="errors.categoryId">
                  {{ errors.categoryId[0] }}
                </div>
              </div>
            </div>

            <div class="col-md-9 col-12 mb-3">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  placeholder=""
                  v-model="description"
                />
                <label class="floatingLabel" for="title">Description</label>
                <div class="invalid-feedback" v-if="errors.description">
                  {{ errors.description[0] }}
                </div>
              </div>
            </div>

            <div class="col-md-12 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="title"
                  placeholder=""
                  v-model="title"
                />
                <label class="floatingLabel" for="title">Subject</label>
                <div class="invalid-feedback" v-if="errors.title">
                  {{ errors.title[0] }}
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="form-group">
                <label class="" for="note">Content</label>
                <vue-editor v-model="content" :editor-toolbar="customToolbar" />
                <div class="invalid-feedback" v-if="errors.content">
                  {{ errors.content[0] }}
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as messageService from '../../services/message.service'
import * as emailTemplateService from '../../services/emailTemplate.service'
import { emailTemplateCategory } from '../../services/data.service'
export default {
  name: 'ModalEmailTemplateNew',
  data() {
    return {
      errors: {},
      categoryId: '',
      description: '',
      content: '',
      title: '',
      isSpinner: false,
      optionCategory: emailTemplateCategory,
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['getEmailTemplatePaginate'])
  },
  methods: {
    ...mapActions(['fetchEmailTemplatePaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    createNew: async function () {
      this.isSpinner = true
      let formData = new FormData()
      formData.append('categoryId', this.categoryId)
      formData.append('description', this.description)
      formData.append('title', this.title)
      formData.append('content', this.content)

      try {
        const response = await emailTemplateService.add(formData)

        this.fetchEmailTemplatePaginate(this.getEmailTemplatePaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Email Template - new',
          'added successfully'
        )

        this.categoryId = ''
        this.description = ''
        this.title = ''
        this.content = ''
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Email Template - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Email Template - new',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    }
  }
}
</script>
